import InventoryUpload from "./settings/InventoryUpload";

const CompanionSettings = () => {
  return (
    <div className="flex flex-1 justify-between flex-col min-h-0">
      <div className="rounded-xl bg-white flex flex-1 flex-col justify-between text-black min-h-0 p-6 dark:bg-gray-800 dark:text-gray-300">
        <InventoryUpload />
      </div>
    </div>
  );
};

export default CompanionSettings;
